/**
 * Шевроны рейтинга обычного (нерейтингового) обличия фракции — поле skinRank
 * в конфигах src/configs/factions/skins: 1–3 — один, два и три серебряных
 * шеврона, 4–6 — один, два и три золотых. Шеврон стоит в правом нижнем углу
 * картинки обличия (см. SkinRankMark).
 *
 * Карта, а не сборка пути из числа: у рейтинга вне 1–6 шеврона нет вовсе, а
 * не битая картинка. С рейтинговыми образами лиг (RANK_SKIN_*, их рамки — см.
 * getRankSkinFramePath) серебро и золото шевронов не связаны.
 */
export const SKIN_RANK_ICON_PATHS = {
  1: '/img/other/skin_rank_icons/skin_rank_silver_1.png',
  2: '/img/other/skin_rank_icons/skin_rank_silver_2.png',
  3: '/img/other/skin_rank_icons/skin_rank_silver_3.png',
  4: '/img/other/skin_rank_icons/skin_rank_gold_1.png',
  5: '/img/other/skin_rank_icons/skin_rank_gold_2.png',
  6: '/img/other/skin_rank_icons/skin_rank_gold_3.png',
};

/**
 * Картинка шевронов по рейтингу обличия.
 *
 * @param {number} [skinRank] - рейтинг обличия (1–6)
 * @returns {string|null} путь к картинке шевронов или null
 */
export const getSkinRankIconPath = (skinRank) => SKIN_RANK_ICON_PATHS[skinRank] || null;
